import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect } from "react-router-dom";

import { Button, Tooltip, Badge, Input, Label } from "reactstrap";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/revisikeuanganService";

import DataTableBloc from "../Blocs/DataTableBloc";
import IndexBloc from "../Blocs/IndexBloc";
import apiResponse from "../../../../../services/apiResponse";
import moment from "moment";
import { Link } from "react-router-dom";

class TableActiveComponent extends Component {
  dataTableBloc = new DataTableBloc();
  indexBloc = new IndexBloc();

  historyTable = "PegawaiPromotionsTableActive";
  defaultOrder = "employee_name";
  defaultSize = 10;
  defaultSort = "asc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };
  modal_confirm_status = 0;
  modal_confirm_message = "";
  modal_confirm_sucess_message = "data berhasil diproses";
  modal_confirm_error_message = "data gagal diproses";

  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      detailUuid: null,
      updateUuid: null,
      updateNip: null,
      inactiveUuid: null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      loadingTable: true,
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
            filter_value: "",
            page_number: 1,
            page_size: this.defaultSize,
            sort_order: {
              column: this.defaultOrder,
              order: this.defaultSort,
            },
          },
      dataSelected: [],
      checkAll: false,
      revision_uuid: null,
      submitType: null,
    };
  }
  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

  loadData = async () => {
    /* history Datatable */
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );

    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      uuid: this.props.uuid,
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
      is_process: 0,
    };
    await this.dataTableBloc.fetchRowTable(query, this.source.token);
  };

  handleChecked = (e, uuid) => {
    var checked = e.target.checked;
    if (checked) {
      this.setState({
        dataSelected: [...this.state.dataSelected, uuid],
      });
    } else {
      var filteredAry = this.state.dataSelected.filter((e) => e !== uuid);
      this.setState({
        dataSelected: filteredAry,
      });
    }
    // console.log(uuid, checked);
  };

  handleCheckAll = (e) => {
    let checked = e.target.checked;
    let uuidSelected = [];
    for (let i = 0; i < this.state.rows.length; i++) {
      let thisId = this.state.rows[i].promotion_id;
      let thisUuid = this.state.rows[i].promotion_uuid;
      this.setState({
        [`check${thisId}`]: !this.state.checkAll,
      });
      if (checked == true) {
        uuidSelected[i] = thisUuid;
      }
    }

    this.setState({
      checkAll: !this.state.checkAll,
      dataSelected: uuidSelected,
    });
  };

  handleButtonProcess = () => {
    // console.log(this.state.dataSelected);
    this.modal_confirm_message =
      "Apakah anda yakin akan menambahkan pegawai terpilih?";
    this.modal_confirm_status = 1;
    this.setState({
      confirm: true,
    });
  };

  resetTable = () => {
    this.setState({
      dataSelected: [],
    });
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };

        if (this.state.submitType == 1) {
          this.inactiveEmployee();
        }

        let data_status = parseInt(this.modal_confirm_status);
        if (data_status === 1) {
          let formData = {
            uuids: this.state.dataSelected,
          };
          //this.indexBloc.fetchProcess(formData)
        } else {
          // this.activeData();
        }
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  inactiveData = async () => {
    await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid });
  };

  inactiveEmployee = async () => {
    await this.dataTableBloc.fetchInactiveEmployee({
      uuid: this.state.deleteUuid,
    });
  };

  exportExcel = () => {
    let additionalFilter = this.props.additionalFilter;
    this.dataTableBloc.fetchRevisiExport({
      uuid: this.props.uuid,
      periode_name: this.props.periode_name,
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      // offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
      ...additionalFilter,
    });

    // console.log(additionalFilter);
  };

  componentDidMount() {
    this.setTokenAPI();

    this.dataTableBloc.rowtableChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;

          // set state for every checkbox
          for (let i = 0; i < response.result.length; i++) {
            let thisId = response.result[i].promotion_id;
            this.setState({
              [`check${thisId}`]: false,
            });
          }
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.revisiExportChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loading: true,
          });
          break;
        case apiResponse.COMPLETED:
          const link = result.data.response;
          window.open(link.file_url, "_blank");
          this.setState({
            loading: false,
            success: true,
          });
          setTimeout(() => {
            this.setState({
              success: false,
            });
          }, 1000);
          break;
        case apiResponse.ERROR:
          this.setState({
            urlFileDetail: link,
            loading: false,
            failed: true,
          });
          setTimeout(function () {
            this.setState({
              failed: false,
            });
          }, 1000);
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.inactiveEmployeeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loading: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          // console.log(response);
          // window.open(link.file_url, "_blank");
          this.setState({
            loading: false,
            success: true,
          });
          setTimeout(() => {
            this.setState({
              success: false,
            });
          }, 1000);
          this.setTokenAPI();
          break;
        case apiResponse.ERROR:
          this.setState({
            // urlFileDetail: link,
            loading: false,
            failed: true,
          });
          setTimeout(function () {
            this.setState({
              failed: false,
            });
          }, 1000);
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.dataTableBloc.rowtableChannel.unsubscribe();
    this.dataTableBloc.revisiExportChannel.unsubscribe();
    this.dataTableBloc.inactiveEmployeeChannel.unsubscribe();
  }

  columns = [
    {
      key: "employee_nip",
      text: "Pegawai",
      className: "",
      sortable: true,
      cell: (record) => {
        return (
          <div
            dangerouslySetInnerHTML={{
              __html:
                "<b>" +
                record.employee_nip +
                "</b><br>" +
                record.employee_full_name +
                "<br>",
            }}
          />
        );
      },
    },
    {
      key: "presensi_summary_revisi_is_tunkin_revisi",
      text: "Jenis Revisi",
      className: "",
      sortable: true,
      cell: (record) => {
        var revhtml = "";
        return (
          <div
            dangerouslySetInnerHTML={{
              __html:
                (record.presensi_summary_revisi_is_tunkin_revisi == 1
                  ? "Revisi Tunkin<br/>"
                  : "") +
                (record.presensi_summary_revisi_is_honorarium_revisi == 1
                  ? "Revisi Honorarium<br/>"
                  : "") +
                (record.presensi_summary_revisi_is_uang_makan_revisi == 1
                  ? "Revisi Uang Makan"
                  : ""),
            }}
          />
        );
      },
    },
    {
      key: "financial_revision_type_name",
      text: "Jenis Koreksi",
      className: "",
      sortable: true,
      cell: (record) => {
        return (
          <div
            dangerouslySetInnerHTML={{
              __html: record.financial_revision_type_name,
            }}
          />
        );
      },
    },

    {
      key: "financial_revision_status",
      text: "Status",
      sortable: false,
      cell: (record) => {
        let status = parseInt(record.financial_revision_status);
        if (status == -1) {
          status = (
            <label className="badge rounded-pill bg-soft-info font-size-12">
              {record.financial_revision_status_name}
            </label>
          );
        } else if (status == 0) {
          status = (
            <label className="badge rounded-pill bg-soft-success font-size-12">
              {record.financial_revision_status_name}
            </label>
          );
        } else if (status == 1) {
          status = (
            <label className="badge rounded-pill bg-soft-success font-size-12">
              {record.financial_revision_status_name}
            </label>
          );
        } else if (status == 2) {
          status = (
            <label className="badge rounded-pill bg-soft-error font-size-12">
              {record.financial_revision_status_name}
            </label>
          );
        }
        return <span> {status} </span>;
      },
    },
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 120,
      sortable: false,
      align: "center",
      cell: (record) => {
        const thisId = record.financial_revision_id;
        return (
          <Fragment>
            {record.financial_revision_status == 0 ? (
              <span>
                <button
                  className="btn btn-primary btn-sm"
                  id={"update-" + thisId}
                  onClick={() => {
                    this.setState({
                      updateUuid: record.financial_revision_employee_uuid,
                      updateNip: record.financial_revision_employee_nip,
                      revision_uuid: record.financial_revision_uuid,
                    });
                  }}
                  style={{
                    marginRight: "2px",
                    padding: "2px 5px",
                  }}
                >
                  {this.props.periode_status == 0 ? (
                    <>
                      <i className="uil-check-square"></i>
                    </>
                  ) : (
                    <>
                      <i className="uil-file-alt"></i>
                    </>
                  )}
                </button>
                <Tooltip
                  style={{
                    marginBottom: 2,
                  }}
                  placement="top"
                  isOpen={this.state["update" + thisId]}
                  target={"update-" + thisId}
                  toggle={() => {
                    this.setState({
                      ["update" + thisId]: !this.state["update" + thisId],
                    });
                  }}
                >
                  {this.props.periode_status == 0
                    ? "Buat Revisi"
                    : "Lihat Revisi"}
                </Tooltip>
              </span>
            ) : null}
            {record.financial_revision_status == 1 ? (
              <span>
                <Link
                  to={
                    `?detail&uuid=` +
                    this.props.uuid +
                    `&pegawai_uuid=` +
                    record.financial_revision_employee_uuid
                  }
                >
                  <button
                    className="btn btn-success btn-sm"
                    id={"detail-" + thisId}
                    style={{
                      marginRight: "2px",
                      padding: "2px 5px",
                    }}
                  >
                    <i className="uil-file-search-alt"></i>
                  </button>
                  <Tooltip
                    style={{
                      marginBottom: 2,
                    }}
                    placement="top"
                    isOpen={this.state["detail" + thisId]}
                    target={"detail-" + thisId}
                    toggle={() => {
                      this.setState({
                        ["detail" + thisId]: !this.state["detail" + thisId],
                      });
                    }}
                  >
                    Detail
                  </Tooltip>
                </Link>
              </span>
            ) : null}

            {/* Hapus pegawai  */}
            {this.props.periode_status == 0 ? (
              <span>
                <button
                  className="btn btn-danger btn-sm"
                  id={"delete-" + thisId}
                  onClick={() => {
                    this.modal_confirm_message =
                      "Apakah anda yakin menghapus data ini?";
                    this.setState({
                      deleteUuid: record.financial_revision_uuid,
                      confirm: true,
                      submitType: 1,
                    });
                  }}
                  style={{
                    marginRight: "2px",
                    padding: "2px 5px",
                  }}
                >
                  <i className="uil-trash-alt"></i>
                </button>
                <Tooltip
                  style={{
                    marginBottom: 2,
                  }}
                  placement="top"
                  isOpen={this.state["delete" + thisId]}
                  target={"delete-" + thisId}
                  toggle={() => {
                    this.setState({
                      ["delete" + thisId]: !this.state["delete" + thisId],
                    });
                  }}
                >
                  Hapus Pegawai
                </Tooltip>
              </span>
            ) : null}
          </Fragment>
        );
      },
    },
  ];

  render() {
    return (
      <>
        <MKIDatatable
          className={this.configDatatable.tableClass}
          config={this.configDatatable}
          records={this.state.rows}
          columns={this.columns}
          dynamic={true}
          minWidth={1000}
          total_record={this.state.totalRow}
          initial={this.state.filter}
          onChange={(filter) => {
            this.setState(
              {
                loadingTable: true,
                filter: filter,
              },
              function () {
                this.setTokenAPI();
              }
            );
          }}
          loading={this.state.loadingTable}
        />
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo={this.modal_confirm_message}
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo={this.modal_confirm_sucess_message}
          failedTitle="Gagal!"
          failedInfo={this.modal_confirm_error_message}
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.detailUuid !== null ? (
          <Redirect
            to={`/kepegawaian/revisi_keuangan.html?pegawai&verifikasi&uuid=${this.props.uuid}&period_promotion_uuid=${this.state.detailUuid}`}
          />
        ) : null}

        {this.state.updateUuid !== null ? (
          <Redirect
            to={`/kepegawaian/revisi_keuangan.html?create_revisi&uuid=${this.props.uuid}&revision_uuid=${this.state.revision_uuid}&pegawai_uuid=${this.state.updateUuid}&pegawai_nip=${this.state.updateNip}`}
          />
        ) : null}

        {/* {console.log(this.state.VerifikasiUuid)} */}
      </>
    );
  }
}

export default TableActiveComponent;
